module.exports = __webpack_public_path__ + "static/media/img-msg-deal@3x.dfbae1ad.png";